import React, { useEffect, useState } from "react";
import { Table, Space, Button, Row, Col, Input, Select, Tooltip, Pagination } from "antd";
import { EditOutlined, SearchOutlined, EyeOutlined } from "@ant-design/icons";
import { imoService } from "../../../services";
import { Link } from "react-router-dom";
import { checkPermission } from "../../../utils/permissions";
import { changeDocumentTitle } from "../../../utils/title";
import { useDebounce } from "../../../hooks/useDebounce";

function LoadingImo() {

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(null)
  const [imo, setIMO] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });

  const debouncedSearch = useDebounce(search, 500);

  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "#",
      key: "_id",
      render: (text, record, index) =>
        (pagination.current - 1) * pagination.pageSize + index + 1,
    },
    {
      title: "Transportation No",
      dataIndex: "transportation_no",
      key: "Transportation No",
    },
    {
      title: "Carrier No",
      dataIndex: "booking_no",
      key: "CarrierNo",
    },
    {
      title: "Container No",
      dataIndex: "ctu_id",
      key: "ContainerNo",
    },
    {
      title: "Seal No",
      dataIndex: "seal_no",
      key: "SealNo",
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record, { _id }) => (
        <Space size="small">
          {checkPermission("VIEW_IMO") && <Link to={`/operations/loadings/imo/edit/${record.id}`} className="hover:text-primary">
            <Tooltip title='Edit'>
              {/* <Button type="primary" size="small"> */}
              <EditOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>}
          {checkPermission("EDIT_IMO") && <Link to={`/operations/loadings/imo/view/${record.id}`} className="hover:text-primary">
            <Tooltip title='View'>
              {/* <Button type="primary" size="small"> */}
              <EyeOutlined />
              {/* </Button> */}
            </Tooltip>
          </Link>}
        </Space>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.current, debouncedSearch) => {
    setLoading(true);
    try {
      const { success, data } = await imoService.fetch(page, pageSize);
      if (success) {
        setIMO(data.data);
        setPagination((prev) => ({
          ...prev,
          total: data.total,
          current: page,
          pageSize,
        }));
      } else {
        console.error("Fetch failed", data);
      }
    } catch (error) {
      console.error("Error fetching IMO data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    changeDocumentTitle("IMO");
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >

      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          IMO Generated
        </h1>
        <Input
          placeholder="Search by Name & Email"
          prefix={<SearchOutlined />}
          style={{
            width: "25%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <Table
        columns={columns}
        dataSource={imo}
        scroll={{ x: "max-content" }}
        style={{ marginTop: "10px" }}
        // pagination={{
        //   current: pagination.current,
        //   total: pagination.total,
        //   pageSize: pagination.pageSize,
        //   onChange: (page) => initialize(page, pagination.pageSize),
        //   showSizeChanger: false,
        // }}
        pagination={false}
        loading={loading}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize, search)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}
export default LoadingImo;
